/* eslint no-inner-declarations: 0 */
/* eslint vars-on-top: 0 */
/* eslint no-console: 0 */
/* eslint no-restricted-syntax: 0 */

import * as Sentry from '@sentry/browser';
import Cookie from 'common/services/util/-RFC.Cookie';
import exceptionHandler from './exceptionHandler';
import appStateDebugger from './appStateDebugger';
import initAppState from './initAppState';
import storeUrlParamLogic from './storeUrlParamLogic';
import { version } from '../../../../package.json';

// Initiate Angular Boostrap App - Workaround to fix the
// compatibility between Angular 1.8.2 and jQuery 3.6.0
setTimeout(() => {

    angular.bootstrap(document.getElementById('oeApp'), ['oe']);

}, 0);

// For local environment, make sure we set the deviceOs to a default

window.deviceOs = window.deviceOs !== '{{ m_os }}' ? window.deviceOs : 'windows';

/* if the server returns MacOSX and we have touch points it
   means that the user is coming from iPad device */
if (window.deviceOs &&
    window.deviceOs.toLowerCase().indexOf('mac') > -1 &&
    window.navigator.maxTouchPoints > 2) {

    window.deviceOs = 'ios';

}

function deepFreeze(object) {

    // Retrieve the property names defined on object
    const propNames = Object.getOwnPropertyNames(object);

    // Freeze properties before freezing self
    propNames.forEach((name) => {

        const value = object[name];

        object[name] = value && typeof value === 'object' ?
            deepFreeze(value) : value;

    });

    return Object.freeze(object);

}


window.CWCONFIG = deepFreeze(window.CWCONFIG);


angular.module('ngModules', ['ngAnimate', 'ngSanitize']);
angular.module('3rdPartyModules', ['pascalprecht.translate',
    'ui.router', 'ui.bootstrap.modal', 'ui.select', 'duScroll', 'pasvaz.bindonce',
    'utf8-base64', 'jQueryScrollbar', 'vcRecaptcha', 'angular-jwt', 'uiCropper']);
angular.module('i18nConfig', []);
angular.module('oe.core', []);
angular.module('oe.enums', []);
angular.module('filters', []);
angular.module('services', []);
angular.module('rest.services', []);
angular.module('models', []);
angular.module('listeners', ['models']);
angular.module('debug', []);
angular.module('decorators', ['debug']);
angular.module('directives', ['templates', 'ngHtmlCompile', 'animations']);
angular.module('animations', []);
angular.module('controllers', ['templates']);
angular.module('resolvers', []);
angular.module('modals', []);
angular.module('templates', []);
angular.module('urls', ['templates', 'resolvers', 'controllers', 'modals']);
angular.module('oe', [
    'ngModules', '3rdPartyModules', 'i18nConfig', 'urls', 'oe.core', 'oe.enums', 'filters',
    'services', 'rest.services', 'directives', 'controllers',
    'animations', 'models', 'listeners', 'resolvers', 'debug', 'decorators',
])
    .config(['$httpProvider', ($httpProvider) => {

        // enable CORS calls
        $httpProvider.defaults.useXDomain = true;
        delete $httpProvider.defaults.headers.common['X-Requested-With'];

        $httpProvider.defaults.headers.common = {};
        $httpProvider.defaults.headers.post = {};
        $httpProvider.defaults.headers.put = {};
        $httpProvider.defaults.headers.patch = {};

        if (!window.appName) {

            window.appName = 'avira';

        }
        if (window.appName.indexOf('partner_id }}') >= 0) {

            window.appName = 'avira';

        }


        const { language, languages } = CWCONFIG;
        const { defaultLanguage } = window;

        // redirect to under maintenance page
        if (CWCONFIG.underMaintenance) {

            if (window.location.pathname.indexOf('under-maintenance') === -1) {

                window.location.href = '/en/under-maintenance';

            }

        }

        if (_.indexOf(_.keys(languages), language) === -1) {

            // redirect with default language
            window.location.pathname = window.location
                .pathname.replace(language, defaultLanguage);

        }

        if (window && window.mixpanel && window.mixpanel.init) {

            window.mixpanel.init(CWCONFIG.mixpanel, { property_blacklist: ['$current_url', 'mp_page'] });

        }

        // Init sentry service

        const { enableSentry } = CWCONFIG;

        if (enableSentry) {

            const sentryDsn = CWCONFIG.sentryConfig.dsn;
            const sentryDebug = CWCONFIG.sentryConfig.debug;

            Sentry.init({
                dsn: sentryDsn,
                debug: sentryDebug,
                beforeSend(event, hint) {

                    if (hint.originalException.indexOf('Timeout') > -1) return null;
                    return event;

                },
                ignoreErrors: [
                    '[$rootScope:inprog] $apply already in progress http://errors.angularjs.org/1.5.11/$rootScope/inprog?p0=%24apply',
                    "Cannot read properties of null (reading 'style')",
                    "Unable to get property 'style' of undefined or null reference",
                    'ErrorPage Opened with status code -1',
                    'Request retrying failed for https://api.my.avira.com/v2/ping with errorCode: -1',
                ],
                release: version,
                environment: 'production',
            });

        }

    }])
    .config(['vcRecaptchaServiceProvider', (vcRecaptchaServiceProvider) => {

        vcRecaptchaServiceProvider.setLang(CWCONFIG.language);
        vcRecaptchaServiceProvider.setGlobal(true);

    }])
    // Angular 1.6.0: "Possibly unhandled rejection" error [duplicate]
    .config(['$qProvider', ($qProvider) => {

        $qProvider.errorOnUnhandledRejections(false);

    }])
    /**
     * Use html5 pushstate if supported
     */
    .config(['$locationProvider', ($locationProvider) => {

        $locationProvider.html5Mode(true);

    }])
    /**
     * Add an interceptor for ajax requests (to prefix requests with the correct cdn)
     */
    .config(['$httpProvider', ($httpProvider) => {

        // Add interceptors to the $httpProvider
        $httpProvider.interceptors.push('LogHttpRESTAPIInterceptor');
        $httpProvider.interceptors.push('RetryRequestInterceptor');

    }])
    /**
     * Get default language and use it for the translation service
     */
    .config(['$translateProvider',
        ($translateProvider) => {

            const { language } = CWCONFIG;
            const { cdn } = CWCONFIG;
            $translateProvider.useStaticFilesLoader({
                prefix: `${cdn}/lang/${process.env.HASH_VALUE}-`,
                suffix: '.json',
            });
            $translateProvider.preferredLanguage(language);
            $translateProvider.useInterpolation('Interpolation');

        }])
    .config(exceptionHandler)
    .run(['$document', ($document) => {

        // Dynamic page title
        $document.prop('title', `My ${CWCONFIG.partnerConfig.name} Account`);

        // Dynamic meta description
        const metaDescription = angular.element('meta[name=description]');
        const { description } = CWCONFIG.partnerConfig;
        metaDescription.attr('content', description);

        // Dynamic favicons
        const cdnAssets = CWCONFIG.cdn_assets;
        const brand = CWCONFIG.partnerConfig.themeId;

        const favicons = [
            {
                tag: 'link',
                rel: 'apple-touch-icon-precomposed',
                sizes: '57x57',
                href: `${cdnAssets}/extras/templates/bba_cw_images/${brand}/favicons/apple-touch-icon-57x57.png`,
            },
            {
                tag: 'link',
                rel: 'apple-touch-icon-precomposed',
                sizes: '114x114',
                href: `${cdnAssets}/extras/templates/bba_cw_images/${brand}/favicons/apple-touch-icon-114x114.png`,
            },
            {
                tag: 'link',
                rel: 'apple-touch-icon-precomposed',
                sizes: '72x72',
                href: `${cdnAssets}/extras/templates/bba_cw_images/${brand}/favicons/apple-touch-icon-72x72.png`,
            },
            {
                tag: 'link',
                rel: 'apple-touch-icon-precomposed',
                sizes: '144x144',
                href: `${cdnAssets}/extras/templates/bba_cw_images/${brand}/favicons/apple-touch-icon-144x144.png`,
            },
            {
                tag: 'link',
                rel: 'apple-touch-icon-precomposed',
                sizes: '60x60',
                href: `${cdnAssets}/extras/templates/bba_cw_images/${brand}/favicons/apple-touch-icon-60x60.png`,
            },
            {
                tag: 'link',
                rel: 'apple-touch-icon-precomposed',
                sizes: '120x120',
                href: `${cdnAssets}/extras/templates/bba_cw_images/${brand}/favicons/apple-touch-icon-120x120.png`,
            },
            {
                tag: 'link',
                rel: 'apple-touch-icon-precomposed',
                sizes: '76x76',
                href: `${cdnAssets}/extras/templates/bba_cw_images/${brand}/favicons/apple-touch-icon-76x76.png`,
            },
            {
                tag: 'link',
                rel: 'apple-touch-icon-precomposed',
                sizes: '152x152',
                href: `${cdnAssets}/extras/templates/bba_cw_images/${brand}/favicons/apple-touch-icon-152x152.png`,
            },
            {
                tag: 'link',
                rel: 'icon',
                type: 'image/png',
                sizes: '196x196',
                href: `${cdnAssets}/extras/templates/bba_cw_images/${brand}/favicons/favicon-196x196.png`,
            },
            {
                tag: 'link',
                rel: 'icon',
                type: 'image/png',
                sizes: '96x96',
                href: `${cdnAssets}/extras/templates/bba_cw_images/${brand}/favicons/favicon-96x96.png`,
            },
            {
                tag: 'link',
                rel: 'icon',
                type: 'image/png',
                sizes: '32x32',
                href: `${cdnAssets}/extras/templates/bba_cw_images/${brand}/favicons/favicon-32x32.png`,
            },
            {
                tag: 'link',
                rel: 'icon',
                type: 'image/png',
                sizes: '16x16',
                href: `${cdnAssets}/extras/templates/bba_cw_images/${brand}/favicons/favicon-16x16.png`,
            },
            {
                tag: 'link',
                rel: 'icon',
                type: 'image/png',
                sizes: '128x128',
                href: `${cdnAssets}/extras/templates/bba_cw_images/${brand}/favicons/favicon-128.png`,
            },
            {
                tag: 'meta',
                name: 'msapplication-TileColor',
                content: '#FFFFFF',
            },
            {
                tag: 'meta',
                name: 'msapplication-TileImage',
                content: `${cdnAssets}/extras/templates/bba_cw_images/${brand}/favicons/mstile-144x144.png`,
            },
            {
                tag: 'meta',
                name: 'msapplication-square70x70logo',
                content: `${cdnAssets}/extras/templates/bba_cw_images/${brand}/favicons/mstile-70x70.png`,
            },
            {
                tag: 'meta',
                name: 'msapplication-square150x150logo',
                content: `${cdnAssets}/extras/templates/bba_cw_images/${brand}/favicons/mstile-150x150.png`,
            },
            {
                tag: 'meta',
                name: 'msapplication-wide310x150logo',
                content: `${cdnAssets}/extras/templates/bba_cw_images/${brand}/favicons/mstile-310x150.png`,
            },
            {
                tag: 'meta',
                name: 'msapplication-square310x310logo',
                content: `${cdnAssets}/extras/templates/bba_cw_images/${brand}/favicons/mstile-310x310.png`,
            },

        ];

        let tag = '';
        favicons.forEach((favicon) => {

            const htmlTag = favicon.tag;
            const rel = favicon.rel ? `rel="${favicon.rel}"` : '';
            const sizes = favicon.sizes ? `sizez="${favicon.sizes}"` : '';
            const href = favicon.href ? `href="${favicon.href}"` : '';
            const type = favicon.type ? `type="${favicon.type}"` : '';
            const name = favicon.name ? `name="${favicon.name}"` : '';
            const content = favicon.content ? `content="${favicon.content}"` : '';

            tag = `<${htmlTag} ${rel} ${type} ${name} ${sizes} ${href} ${content} />`;
            tag = tag.replace(/^(\s*)|(\s*)$/g, '').replace(/\s+/g, ' ');

            angular.element(tag).appendTo('head');

        });

    }])
    .run(['$rootScope', '$window',
        ($rootScope, $window) => {

            const cookieLang = CWCONFIG.cookie.language;
            const { rootDomain } = CWCONFIG.cookie;

            $rootScope.cdn = CWCONFIG.cdn;
            $rootScope.appName = $window.appName;

            // we use this variable to determine when to show the confirm page
            $rootScope.newRegisteredUser = false;

            // Set language cookie (duration, path and domain)
            Cookie.set(cookieLang, CWCONFIG.language, {
                expires: 30,
                path: '/',
                domain: rootDomain || 'avira.com',
            });

        }])
    .run(appStateDebugger)
    .run(initAppState)
    .run(['$rootScope', '$location', 'Auth',
        ($rootScope, $location, Auth) => {

            // Clear any cookie if page url is register, forgot or reset
            if (/auth\/register/.test($location.path()) ||
                /auth\/forgot/.test($location.path()) ||
                /auth\/reset/.test($location.path())) {

                Auth.removeLoginCookies();

            }

            if (window.location.href.indexOf('callback=coinbase') > -1) {

                if (window.opener) {

                    window.opener.parent.postMessage('coinbase_login', window.location.origin);
                    window.close();

                }

            }

            $rootScope.$on('$stateChangeSuccess', (event, toState) => {

                // set noScroll when modals are opened
                let noScroll = false;

                if (toState.url) {

                    $rootScope.State.page = toState.url;
                    $rootScope.State.state = toState.name;

                }

                noScroll = _.indexOf([
                    'dashboard.ltb',
                    'dashboard.ltb.next',
                    'dashboard.ltb.service',
                    'dashboard.ltb.service.deviceid',
                    'dashboard.ltb.devicetype',
                    'dashboard.device_details',
                    'dashboard.device_details.ltb',
                    'dashboard.device_details.ltb.next',
                    'dashboard.device_details.service',
                    'dashboard.device_details.service.ltb',
                    'dashboard.device_details.service.ltb.next',
                    'dashboard.device_details.service.ltb.profile',
                    'apps.product.ltb',
                    'apps.product.ltb.screen',
                    'apps.main.ltb',
                    'apps.main.ltb.info',
                    'dashboard.ltb.summary',
                    'dashboard.ltb.service.embedded',
                    'notAllowed',
                ], toState.name) !== -1;

                if (!$rootScope.State.ftu) {

                    $rootScope.State.noscroll = noScroll;

                }

            });

        }])
    /**
     * Store each page route upon navigation
     */
    .run(storeUrlParamLogic);




// WEBPACK FOOTER //
// ./scripts/app/main.js